import { render, staticRenderFns } from "./ReportingProfileAccountsTable.vue?vue&type=template&id=6f2ddd0c&"
import script from "./ReportingProfileAccountsTable.vue?vue&type=script&lang=js&"
export * from "./ReportingProfileAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports